import React from 'react';
import {
  GDSTextActionIndicator,
  GDSTextActionSize,
  GDSIconSource,
} from '@leagueplatform/genesis-core';
import {
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../utils/format-masonry-class-name.util';
import { MasonryDriverAction } from '../../types/masonry-driver-node-actions';
import {
  MasonryTextAction,
  type MasonryTextActionVariant,
} from '../common/masonry-text-action/masonry-text-action.component';

export type MasonryTextActionNodeProperties = {
  // TODO: Add all icons that can be passed to text actions.
  icon?: GDSIconSource;
  indicator?: TextActionIndicatorOptions;
  size?: GDSTextActionSize;
  text: string;
  variant?: MasonryTextActionVariant;
  loading?: boolean;
};

type TextActionIndicatorOptions =
  | 'disclosure'
  | 'newWindowInternal'
  | 'externalLink'
  | 'none';

const indicatorIconMap: {
  [key in TextActionIndicatorOptions]: GDSTextActionIndicator | undefined;
} = {
  disclosure: 'disclosure',
  externalLink: 'externalLink',
  newWindowInternal: 'newTabInternal',
  none: undefined,
};

type MasonryTextActionNodeActions = {
  onClick?: MasonryDriverAction;
};

export type MasonryTextActionNode = MasonryEngineNode<
  'textAction',
  MasonryTextActionNodeProperties,
  MasonryTextActionNodeActions
>;

export type MasonryTextActionRendererProps =
  MasonryEngineNodeRendererProps<MasonryTextActionNode>;

export const MasonryTextActionRenderer = ({
  css,
  icon,
  indicator: indicatorName = 'none',
  onClick,
  size = 'large',
  text,
  variant,
  className,
  engineClassName,
  locatorId,
  loading,
  rootElementRef,
}: MasonryTextActionRendererProps) => {
  if (!text) {
    return null;
  }
  const indicator = indicatorIconMap[indicatorName];

  return (
    <MasonryTextAction
      ref={rootElementRef}
      icon={icon}
      indicator={indicator}
      size={size}
      text={text}
      onClick={onClick}
      variant={variant}
      className={formatClassNames(engineClassName, className)}
      data-testid={locatorId}
      loading={loading}
      css={css}
    />
  );
};
